<template>
  <div class="dlnkactions_component w-100">

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <div class="modal fade text-body" id="action_modal" tabindex="-1" role="dialog" aria-labelledby="new_action_modal_label">
      <form id="action_form"
            method="post"
            @submit.prevent="post_action">
        <input type="hidden" name="idea[group_id]" :value="group_id">

        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="new_action_modal_label">Ajouter</h4>
              <button
                  :disabled="submit_disabled == true"
                  type="submit"
                  class="btn btn-primary"
                  name="new_actiont" >
                <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
              </button>

              <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                  aria-hidden="true">&times;</span></button>

            </div>
            <div class="modal-body">
              <div class="form-group required">
                <label for="theme_id" class="required">Thème :</label>
                <select id="theme_id" name="idea[id_theme]" class="form-control form-control-sm">
                  <option
                      v-for="theme in themes"
                      :key="theme.id"
                      :value="theme.id">
                    {{theme.title}}
                  </option>
                </select>
              </div>

              <!-- TITLE -->
              <div class="form-group required">
                <label for="title" class="required">Titre :</label>
                <input id="title" name="idea[title]" type="text"
                       class="is_required form-control"
                       :class="{'is-invalid': errors.title}"
                       @blur="validate_title"
                       v-model="title">
                <div class="invalid-feedback">
                  Le titre doit contenir entre 3 et 128 caractères.
                </div>
              </div>

              <!-- DESCRIPTION -->
              <div class="required form-group">
                <label for="description" class="">
                  Description
                </label>

                <textarea id="description"
                          name="idea[description]" rows="5"
                          class="form-control"
                          :class="{'is-invalid': errors.description}"
                          @blur="validate_description"
                          v-model="description">
                </textarea>

                <div class="invalid-feedback">
                  La description doit contenir 3 et 400 caractères.
                </div>
              </div>

              <!-- IMAGE -->
              <div class="form-group">
                <label for="image" class="">
                  Image
                </label>

                <div class="media align-items-center">


                    <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                            data-toggle="tooltip" data-placement="top"
                            title="Image">
                      <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                           id="image"
                           :src="image"
                           alt="Image"/>
                      <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                        Ajouter / modifier l'image'
                        <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                           data-target="#change_image">
                          <i class="fa fa-question-circle"></i>
                        </a>
                      </figcaption>
                    </figure>

                    <dlnk-clipper
                        modal_id="change_image"
                        @imgURL="set_image($event)"
                        :crop_ratio="1">
                    </dlnk-clipper>


                  </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
              </button>
              <button
                  :disabled="submit_disabled == true"
                  type="submit"
                  class="btn btn-primary"
                  name="new_actiont" >
                <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>

    <div class="row">
      <!-- Side -->
      <div v-if="single_page" class="col-lg-3 mb-5 mb-lg-0">
        <div class="mr-lg-3">
          <!-- Navbar -->
          <div class="navbar-expand-lg navbar-expand-lg-collapse-block navbar-light px-3">
            <!-- Responsive Toggle Button -->
            <button type="button" class="navbar-toggler btn btn-block border py-3"
                    aria-label="Toggle navigation"
                    aria-expanded="false"
                    aria-controls="sidebarNav"
                    data-toggle="collapse"
                    data-target="#sidebarNav">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="h5 mb-0">Voir toutes les catégories</h5>
                <span class="navbar-toggler-default">
                  <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"/>
                  </svg>
                </span>
                <span class="navbar-toggler-toggled">
                  <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"/>
                  </svg>
                </span>
              </div>
            </button>
            <!-- end Responsive Toggle Button -->
            <div id="sidebarNav" class="collapse navbar-collapse">
              <div class="py-2 p-lg-0">
                <div class="mt-3 mt-lg-0">

                  <div class="dropdown mb-3">
                    <button id="dropdown-sort" class="btn btn-primary dropdown-toggle btn-block"
                            type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-filter mr-2"></i>Trier par
                    </button>
                    <div class="dropdown-menu dropdown-sort">
                      <a class="dropdown-item" href="javascript:" @click="sort('updated_at', 'desc')">
                        Date d'ajout (plus récents)
                      </a>
                      <a class="dropdown-item" href="javascript:" @click="sort('updated_at', 'asc')">
                        Date d'ajout (plus anciens)
                      </a>
                    </div>
                  </div>

                  <!-- SEARCH -->
                  <h4 class="h4">Rechercher</h4>
                  <div class="row mb-3">
                    <div class="col-12">
                      <input v-on:keyup="search_actions" type="text" placeholder="Par thème ou par titre…" class="form-control form-control-sm w-100 border" v-model="query">
                    </div>
                  </div>
                  <!-- END SEARCH -->

                  <h4 class="h4">Explorer</h4>
                  <!-- Nav Link -->

                  <div id="sortByTheme" class="mb-3">
                    <a id="0" class="d-block btn btn-soft-primary text-left mb-2 active" href="javascript:" @click="toggle_theme(0)">
                      Toutes les idées
                    </a>

                    <h6 class="h6 mt-3">Liste des thèmes</h6>

                    <a class="d-block btn btn-soft-primary text-left mb-2"
                       href="javascript:"
                       v-for="theme in used_themes"
                       v-text="theme.title"
                       :key="theme.id"
                       :id="theme.id"
                       @click="toggle_theme(theme.id);">
                    </a>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- end Navbar -->
        </div>
      </div>
      <div v-else class="col-12 mb-5 mb-lg-0">

        <div id="sortByTheme" class="mb-3">
          <span class="text">Catégories :</span>

          <a id="0" class="badge badge-soft-primary mb-2 active" href="javascript:" v-on:click="toggle_theme(0)">
            Toutes
          </a>

          <a class="badge badge-soft-primary text-left mx-1 mb-2"
             href="javascript:"
             v-for="theme in used_themes"
             v-text="theme.title"
             :key="theme.id"
             :id="theme.id"
             @click="toggle_theme(theme.id);">
          </a>

        </div>

        <div class="row mb-3">
          <div class="col-4 d-flex align-items-center justify-content-center justify-content-md-end text-center text-sm-left">
              <div class="dropdown dropleft">
                <button id="dropdown-sort" class="btn btn-primary dropdown-toggle btn-block"
                        type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-filter mr-2"></i>Trier par
                </button>
                <div class="dropdown-menu dropdown-sort">
                  <a class="dropdown-item" href="javascript:" @click="sort('updated_at', 'desc')">
                    Date d'ajout (plus récents)
                  </a>
                  <a class="dropdown-item" href="javascript:" @click="sort('updated_at', 'asc')">
                    Date d'ajout (plus anciens)
                  </a>
                </div>
              </div>
          </div>

          <!-- SEARCH -->
          <div class="col-4">
            <input v-on:keyup="search_actions" type="text" placeholder="Rechercher par thème ou par titre…" class="form-control-sm w-100 border" v-model="query">
          </div>
          <!-- END SEARCH -->
          <div class="col-4">

            <button @click="new_action()"
                    type="button"
                    class="btn btn-primary float-right ml-1">
              <i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Proposer une nouvelle idée
            </button>
          </div>

        </div>
      </div>
      <!-- end Side -->

      <!-- Main -->
      <div v-if="single_page" class="col-lg-9 column-divider-lg">
        <div class="ml-lg-2">

          <div class="row mx-n2 mb-7">
            <dlnkactions-action
                v-for="action in actions"
                :key="action.id"
                v-bind:action="action"
                v-bind:customer_id = "customer_id"
                v-bind:theme = "Number(theme)"
                v-bind:id_theme="theme_id"
                v-bind:single_page="single_page"
                @like="like($event)"
                @dislike="dislike($event)"
            ></dlnkactions-action>
          </div>


        </div>
      </div>
      <div v-else class="col-12">
        <div class="ml-lg-2">
          <div class="row mx-n2 mb-7">
            <dlnkactions-action
                v-for="action in actions"
                :key="action.id"
                v-bind:action="action"
                v-bind:theme = "Number(theme)"
                v-bind:id_theme="theme_id"
                v-bind:single_page="single_page"
                @like="like($event)"
                @dislike="dislike($event)"
            ></dlnkactions-action>
          </div>


        </div>
      </div>
      <!--end Main -->

    </div><!--end row -->
  </div><!--end dlnkactions_component -->
</template>

<script>

export default {
  props: {
    'group_id': Number,
    'single_page': Boolean
  },
  data: function () {
    return {
      themes: [],
      used_themes: [],
      actions: [],
      query: '',
      order_by: 'id',
      order_direction: 'desc',
      theme: 0,
      action_id: 0,
      title: '',
      description: '',
      company: Object,
      is_public: false,
      theme_id: 0,
      is_community: false,
      is_admin: false,
      customer_id: 0,
      image: "",
      message: "",
      message_type: '',
      method: 'post',
      errors: {
        title: false,
        description: false,
        theme: false,
      },
      wait_data: Boolean,
    }
  },
  mounted() {
    this.wait_data = true
    this.get_actions()
    this.get_themes()
  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  methods: {
    close_message: function () {
      this.message = null;
    },

    set_image: function (img_url) {
      this.image = img_url
    },

    get_themes: async function () {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/themes.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer_id = customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.themes = response.data.themes
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_data: function() {
      this.get_actions()
      this.get_themes()
    },

    get_actions: async function () {
      const _this = this
      _this.wait_data = true
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      if (typeof _this.group_id !== 'undefined') {
        api_url += '&group_id=' + _this.group_id
      }

      api_url += '&query=' + _this.query
      api_url += '&order_by=' + _this.order_by
      api_url += '&order_direction=' + _this.order_direction


      axios.get( api_url)
          .then(function (response) {
            _this.actions = response.data.ideas
            _this.used_themes = response.data.used_themes
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            _this.wait_data = false
          });
    },

    new_action: function(action) {
      this.action_id = 0;
      this.title = "";
      this.description = "";
      this.theme_id = 0;
      this.method = 'post'

      $('#action_modal').modal('show');
    },

    post_action: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_element = document.getElementById("action_form");
      const form_data = new FormData(form_element);
      form_data.append('image_base64', _this.image)

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.message = "L'idée a été proposé. Elle est en attente de validation";
            _this.message_type = "alert-success";
            _this.get_data()
            $('#action_modal').modal('hide');
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";

            // _this.message = "Une erreur est survenue.";
            // _this.message_type = "alert-danger";
          });
    },

    like: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/like.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'post',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";
          });
    },

    dislike: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/dislike.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'delete',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";

            // _this.message = "Une erreur est survenue.";
            // _this.message_type = "alert-danger";
          });
    },

    toggle_theme: function (id) {
      let allCards = $('.card-action');
      let chosenCards = $(String('.action-theme-' + id));

      if ( id === 0 ) {
        allCards.show();
      } else {
        allCards.hide();
        chosenCards.show();
      }

      $('#sortByTheme').children().removeClass('active');
      $('#sortByTheme').children( '#' + id ).addClass('active');
    },

    sort: function (order_by, order_direction) {
      const _this = this;

      _this.get_actions();
      _this.order_by = order_by;
      _this.order_direction = order_direction;
      $('#dropdown-sort').dropdown('toggle');
    },

    validate_title: function () {
      this.errors.title = false;
      if(this.title.length < 3 || this.title.length > 128) {
        this.errors.title = true;
      }
    },

    validate_description: function () {
      this.errors.description = false;
      if(this.description.length < 3 || this.description.length > 400) {
        this.errors.description = true;
      }
    },

    search_actions(id) {
      this.get_actions();
    }
  }
}
</script>